import React from 'react'
import MediaQuery from "react-responsive";
import Icon from '../icon'
import GooglePlay from "../../images/button-google-play.png";
import AppStore from "../../images/button-app-store.png";
import * as S from "./styles";

export function Footer() {
  return (
    <>
      <S.Footer>
        <S.LinksLeft>
          <MediaQuery query="(min-width: 768px)">
            {/* <S.Link href="https://www.biologiatotal.com.br/cursos/reforco-universitario?utm_source=home&utm_medium=rodape" menu>
              Reforço Universitário
            </S.Link> */}
            <S.Link href="https://aprovatotal.zendesk.com" menu>
              Central de ajuda
            </S.Link>
            <S.Link href="https://aprovatotal.com.br/blog/" menu>
              Blog
            </S.Link>
            <S.Link href="https://www.aprovatotal.com.br/termos-de-uso" rel="noopener noreferrer" target="_blank" menu>
              Termos de uso
            </S.Link>
            <S.Link href="https://www.aprovatotal.com.br/politica-de-privacidade" rel="noopener noreferrer" target="_blank" menu>
              Política de Privacidade
            </S.Link>
          </MediaQuery>
          <S.Link href="https://api.whatsapp.com/send?phone=5548991099403" rel="noopener noreferrer" target="_blank" isWpp={true}>
            <Icon icon="wpp" width={29} height={24} />48 99109-9403
          </S.Link>
        </S.LinksLeft>
        <S.Social>
          <S.StoreButtons>
            <S.Link href="https://play.google.com/store/apps/details?id=br.com.aprovatotal&hl=pt_BR" rel="noopener noreferrer" title="Google Play" target="_blank">
              <S.Image src={GooglePlay} alt="Google Play" title="Google Play" />
            </S.Link>
            <S.Link href="https://apps.apple.com/br/app/aprova-total-curso-enem/id1462286487" rel="noopener noreferrer" title="App Store" target="_blank">
              <S.Image src={AppStore} alt="App Store" title="App Store" />
            </S.Link>
          </S.StoreButtons>
          <S.SocialButtons>
            <S.Link href="https://www.youtube.com/c/AprovaTotal" rel="noopener noreferrer" target="_blank">
              <Icon icon="youtube" width={34} height={24} />
            </S.Link>
            <S.Link href="https://www.instagram.com/aprovatotal" rel="noopener noreferrer" target="_blank">
              <Icon icon="instagram" width={24} height={24} />
            </S.Link>
            <S.Link href="https://www.facebook.com/Aprova-Total-100719195266333" rel="noopener noreferrer" target="_blank">
              <Icon icon="facebook" width={24} height={24} />
            </S.Link>
            <S.Link href="https://twitter.com/aprovatotal" rel="noopener noreferrer" target="_blank">
              <Icon icon="twitter" width={29} height={24} />
            </S.Link>
          </S.SocialButtons>
        </S.Social>
      </S.Footer>
    </>
  )
}